import React from 'react';
interface StatusSummaryCardsProps {
  counts: {
    new: number;
    requested: number;
    review: number;
    cleared: number;
  };
}
export function StatusSummaryCards({
  counts
}: StatusSummaryCardsProps) {
  return <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8" data-id="element-270">
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-271">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-272">
          New
        </span>
        <span className="text-3xl font-light text-blue-600" data-id="element-273">{counts.new}</span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-274">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-275">
          Requested
        </span>
        <span className="text-3xl font-light text-amber-600" data-id="element-276">
          {counts.requested}
        </span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-277">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-278">
          Review
        </span>
        <span className="text-3xl font-light text-purple-600" data-id="element-279">
          {counts.review}
        </span>
      </div>
      <div className="bg-white border border-slate-200 rounded-lg p-4 flex flex-col items-center justify-center shadow-sm" data-id="element-280">
        <span className="text-xs font-medium text-slate-500 uppercase tracking-wider mb-1" data-id="element-281">
          Cleared
        </span>
        <span className="text-3xl font-light text-emerald-600" data-id="element-282">
          {counts.cleared}
        </span>
      </div>
    </div>;
}